// import ar from "./locales/ar.json";
// import en from "./locales/en.json";
// import ru from "./locales/ru.json";
// import uz from "./locales/uz.json";
import { createI18n } from "vue-i18n";

let lang = null;
let langCookie = document.cookie.match(/lang=[a-zA-Z0-9]{1,}/);

if (langCookie) {
  lang = langCookie[0].slice(5);
}
else {
  lang = process.env.VUE_APP_DEFAULT_LOCALE ? process.env.VUE_APP_DEFAULT_LOCALE : "en";
}

export const setLocale = async (locale) => {
  const messages = await import(`./locales/${locale}.json`);
  i18n.global.setLocaleMessage(locale, messages.default);
  i18n.global.locale = locale;
};

setLocale(lang);

const i18n = createI18n({
  locale: lang,
  fallbackLocale: lang,
  globalInjection: true,
  pluralizationRules: {
    ru: function (choice, choicesLength) {
      if (choice === 0) {
        return 0;
      }

      const teen = choice > 10 && choice < 20;
      const endsWithOne = choice % 10 === 1;

      if (choicesLength < 4) {
        return (!teen && endsWithOne) ? 1 : 2;
      }
      if (!teen && endsWithOne) {
        return 1;
      }
      if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
        return 2;
      }

      return (choicesLength < 4) ? 2 : 3;
    }
  }
});

export default i18n;
